import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import FundOpportunity from '../../../models/FundOpportunity';
import { fmtCurrency, fundStatusColor, fundStatusLabel } from './contactOpportunitiesUtils';

export default function AvailableFundCard({
  fund,
  navigate,
}: {
  fund: FundOpportunity;
  navigate: (path: string) => void;
}) {
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/opportunities/${fund.id}`);
      }}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        bgcolor: 'background.paper',
        cursor: 'pointer',
        '&:hover': { bgcolor: 'action.hover' },
        transition: 'background-color 0.15s',
      }}
    >
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}
      >
        <Typography
          variant="subtitle2"
          fontWeight={700}
          noWrap
          sx={{ flex: 1 }}
          title={fund.name ?? ''}
        >
          {fund.name}
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.75, ml: 1, flexShrink: 0, alignItems: 'center' }}>
          <Chip
            label={fundStatusLabel(fund.status)}
            color={fundStatusColor(fund.status)}
            size="small"
          />
          <OpenInNewIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {fund.fundSize != null && (
          <Typography variant="caption" color="text.secondary">
            Fund size: {fmtCurrency(fund.fundSize)}
          </Typography>
        )}
        {fund.closeDate && (
          <Typography variant="caption" color="text.secondary">
            · Closes{' '}
            {new Date(fund.closeDate).toLocaleDateString('en-AU', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })}
          </Typography>
        )}
        {fund.returnOnInvestment != null && (
          <Typography variant="caption" color="text.secondary">
            · Target ROI {fund.returnOnInvestment}%
          </Typography>
        )}
      </Box>

      {(fund.state || fund.country) && (
        <Typography variant="caption" color="text.disabled" sx={{ mt: 0.5, display: 'block' }}>
          {[fund.state, fund.country].filter(Boolean).join(', ')}
        </Typography>
      )}
    </Box>
  );
}
